<template>
    <div class="flex-between">
        <el-card v-for="(item,i) in list" :key="i" shadow="hover" class="data-box" :style="{background:'url('+item.image+') no-repeat'}">
            <div class="container">
                <div class="center">
                    <p>{{item.data}}</p>
                </div>
            </div>
        </el-card>
    </div>
</template>
<script>
export default {
    data() {
        return{
            list: [
                {icon:'#iconnecessary',title:'必修課程',image:require('@p/assets/images/necessary.png'),data:0},
                {icon:'#iconlearningTime',title:'學習時長',image:require('@p/assets/images/learning-time.png'),data:0},
                {icon:'#iconlessonJoin',title:'已參加課程',image:require('@p/assets/images/lesson-join.png'),data:0},
                {icon:'#iconlessonComplete',title:'已完成課程',image:require('@p/assets/images/lesson-finish.png'),data:0},
                {icon:'#iconlessonLow',title:'歷史最低分',image:require('@p/assets/images/lesson-low.png'),data:0},
                {icon:'#iconlessonMax',title:'歷史最高分',image:require('@p/assets/images/lesson-max.png'),data:100},
            ]
        }
    },
    created(){
        this.getMyStudyData()
    },
    methods:{
        async getMyStudyData(){
            await this.$http.personal.getMyStudyData().then(res=>{
                if(res.status === 200){
                    let resData = res.data.data;
                    this.list[0].data = resData.requird_courses;
                    this.list[1].data = resData.study_time;
                    this.list[2].data = resData.parted_courses;
                    this.list[3].data = resData.complete_courses;
                }
            }).catch(v=>{})
        },
    }
}
</script>
<style lang="less" scoped>
.flex-between{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
}
.data-box{
    width: 380px;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    margin-bottom: 20px;
    .container{
        width:250px;
        display: flex;
        justify-content: center;
        .center{
            margin-top: 30px;
            font-size: 64px;
        }
    }
}
</style>